export default "__VITE_ASSET__CEVpz27c__"